module.exports = __webpack_public_path__ + "img/18.99afae06.png";